

































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import {
  HomebannerState,
  HomebannerModule,
} from '@/app/store/modules/homebanner'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  name: 'SalesmanBulletin',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  public searchInput = ''
  private selected = []

  public created() {
    HomebannerModule.paginationParam.search = ''
    this.getImage()
    this.getHomebanner()
  }

  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }
  public getHomebanner() {
    HomebannerModule.getHomebannerData()
  }

  public get homebannerData() {
    return HomebannerModule.homebannerData
  }

  public get isLoading() {
    return HomebannerModule.isLoading
  }
  public get page() {
    return HomebannerModule.Pages
  }
  public get limit() {
    return HomebannerModule.Limit
  }

  public get fields() {
    return HomebannerModule.fields
  }

  private onPageNumChanged(limit: any) {
    HomebannerModule.paginationParam.paging.limit = limit
    this.getHomebanner()
  }

  private funcFirstPage() {
    HomebannerModule.paginationParam.paging.page = 1
    this.getHomebanner()
  }

  private funcPrevPage() {
    HomebannerModule.paginationParam.paging.page =
      HomebannerModule.paginationParam.paging.page - 1
    this.getHomebanner()
  }
  private funcNextPage() {
    HomebannerModule.paginationParam.paging.page =
      HomebannerModule.paginationParam.paging.page + 1
    this.getHomebanner()
  }

  private funcLastPage() {
    HomebannerModule.paginationParam.paging.page =
      (this.homebannerData.pagination &&
        this.homebannerData.pagination.pageCount) ||
      0
    this.getHomebanner()
  }
  private onRowSelected(items) {
    this.selected = items
  }
  private funcSearch(item) {
    HomebannerModule.paginationParam.search = item
    this.getHomebanner()
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
